import { useEffect, useState } from 'react';
import { RouterBridge } from './router-bridge';
/**
 * This hook returns route params(for example id from /users/:id)
 */
export var useRouteParams = function () {
    var _a = useState(RouterBridge.getParamsOnce()), params = _a[0], setParams = _a[1];
    useEffect(function () {
        var unsubscribe = RouterBridge.subscribeToParams(function (nextState) {
            setParams(nextState);
        });
        return unsubscribe;
    }, []);
    return params.params;
};
/**
 * This hook returns route query params(for example utm_source from /users?utm_source=google)
 */
export var useRouteQuery = function () {
    var _a = useState(RouterBridge.getParamsOnce()), params = _a[0], setParams = _a[1];
    useEffect(function () {
        var unsubscribe = RouterBridge.subscribeToParams(function (nextState) {
            setParams(nextState);
        });
        return unsubscribe;
    }, []);
    return params.query;
};
